import { Box, Typography } from '@mui/material';
import React from 'react';
import { useUserContext } from '../modules/user/UserContext';

const Profile = () => {

  const { user,isAdmin } = useUserContext();

  // console.log("userProfile",user)

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <Box mt={2} p={2} border="1px solid #ccc" borderRadius="8px">
      <Typography variant="h4" gutterBottom>
        User Profile
      </Typography>

      { user ? (
        <Box>
          <Typography variant="body1">
            <strong>Username:</strong> {user.username}
          </Typography>
          <Typography variant="body1">
            <strong>Email:</strong> {user.email}
          </Typography>
          <Typography variant="body1">
            <strong>Role:</strong> {user.role.name}
          </Typography>
          <Typography variant="body1">
            <strong>Document ID:</strong> {user.documentId}
          </Typography>
          {/* <Typography variant="body1">
            <strong>Is Active:</strong> {user.isActive ? 'Yes' : 'No'}
          </Typography>
          <Typography variant="body1">
            <strong>Stripe Customer ID:</strong> {user.stripeCustomerId}
          </Typography> */}
          <Typography variant="body1">
            <strong>RL MW USER ID:</strong> {user.RL_MW_USER_ID}
          </Typography>
          <Typography variant="body1">
            <strong>Is Blocked:</strong> {user.blocked ? 'Yes' : 'No'}
          </Typography>
        </Box>
      ) : (
        <Typography variant="body1" color="error">
          No user details found. Please log in.
        </Typography>
      )}
    </Box>
  );
};

export default Profile;
